import { usePage } from "@inertiajs/react"

interface Auth {
  user: {
    id: number
    name: string
    email: string
    verified: boolean
    avatar_url?: string | null
    role?: string
    is_admin?: boolean
    neighborhood?: {
      id: number
      name: string
    } | null
    favorites_count?: number
    points?: number
    created_at: string
    updated_at: string
  } | null
  session: {
    id: number
  } | null
  is_authenticated: boolean
}

export function useAuth() {
  const { props } = usePage()
  const auth = props.auth as Auth

  return {
    user: auth?.user ?? null,
    session: auth?.session ?? null,
    isAuthenticated: auth?.is_authenticated ?? false,
  }
}
